export default __webpack_public_path__ + "static/media/info-logo.fbd16414.svg";